/* Dear eM – em-qa-fix.js (v26.3 · 24/10/2026, Claude) — sửa các lỗi QA ngày 23/10 (CEO duyệt):
 * 1) Gợi ý "Phóng to để xem cận cảnh": tự chọn chỗ đặt không đè lên chữ/icon (dưới-giữa → dưới-phải → dưới-trái → trên-giữa → trên-trái).
 * 2) Bước "Xem lại trước khi đặt" trên điện thoại: hình demo phóng to cho hết khoảng trắng phía dưới.
 * 3) Thêu ảnh: nút X luôn nằm trên cùng (điện thoại bị hình che); mở khung là thu nhỏ sẵn (giống thêu tên);
 *    icon chọn ảnh dùng SVG thay emoji; máy tính: thanh nút dưới cùng không bị danh sách font đè lên.
 * 4) Thiệp / hộp quà / túi giấy (template dearem-gift): bỏ chữ "cá nhân hoá" không đúng; ô lời chúc nằm trong bảng Mua ngay.
 * 5) Bảng Mua ngay (điện thoại): ảnh phân loại cạnh giá nằm gọn trong bảng (trước đây trồi lên trên mép bảng 36px).
 * 6) (v26.3) Dòng chữ dưới giá trong bảng Mua ngay của SP quà không còn nhảy qua lại với "Chọn phân loại".
 * 7) (v27.8 · 26/10/2026) Thêu ảnh, bước Xem lại trên điện thoại: ảnh demo thu nhỏ đúng như thêu tên để thấy đủ Tên thêu/Font/Màu chỉ + ô đồng ý
 *    (lỗi: fillConfirm đo nhầm bảng chỉnh đang ẩn → ảnh demo chiếm 358px, mục xác nhận bị đẩy xuống dưới, phải cuộn mới thấy).
 * Nạp từ snippets/em-customizer-patch.liquid (mọi trang sản phẩm). Không sửa file gốc.
 */
(function () {
  'use strict';
  if (window.__emQaFix) return; window.__emQaFix = 1;
  var H = document.documentElement, mqM = window.matchMedia('(max-width: 749px)');

  var css =
    /* 3) thêu ảnh: nút X trên cùng, thanh nút dưới không bị đè */
    '.dmp-modal .dmp-close{z-index:40!important}' +
    '.dmp-modal .dmp-foot{z-index:30!important;background:#fff!important}' +
    '.dmp-drop__icon.em-svgi svg{width:30px;height:30px;stroke:#7f63bd;fill:none;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round}' +
    /* 1) chip đặt lại vị trí bằng JS */
    '.dmc-modal .tt-zchip.em-zpos{animation:none!important;transform:none!important}' +
    '.dmc-modal .tt-zchip.em-zpos.is-out{opacity:0;transition:opacity .3s}' +
    /* 5) bảng Mua ngay: ảnh phân loại cạnh giá nằm gọn trong bảng, không trồi lên trên */
    '.tt-vsheet .tt-vhead__img{margin-top:0!important;width:72px!important;height:72px!important;flex:0 0 72px}' +
    '.tt-vsheet .tt-vhead__sel.em-vsel-off{display:none!important}';
  var st = document.createElement('style'); st.id = 'em-qa-fix'; st.textContent = css;
  (document.head || H).appendChild(st);

  function rectsHit(a, b) { return !(a.r <= b.l || b.r <= a.l || a.b <= b.t || b.b <= a.t); }
  function R(r) { return { l: r.left, t: r.top, r: r.right, b: r.bottom }; }

  /* ---------- 1) vị trí gợi ý phóng to ---------- */
  function placeChip(m) {
    var chip = m.querySelector('.tt-zchip');
    if (!chip || chip.__emPlaced || chip.classList.contains('is-out')) return;
    var stg = chip.parentElement, cv = m.querySelector('.dmc-stage > .dmc-canvas:not(.dmc-canvas--clone)');
    if (!stg || !cv) return;
    chip.__emPlaced = 1;
    var obs = [].slice.call(cv.querySelectorAll('.dmc-el')).filter(function (e) { return e.offsetWidth > 0 && (e.textContent.trim() || e.querySelector('img,svg')); })
      .map(function (e) { return R(e.getBoundingClientRect()); });
    var sel = cv.querySelector('.dmc-sel.is-visible'); if (sel) obs.push(R(sel.getBoundingClientRect()));
    var c = chip.getBoundingClientRect(), s = stg.getBoundingClientRect(), k = cv.getBoundingClientRect();
    if (!obs.some(function (o) { return rectsHit(R(c), o); })) return; /* chỗ mặc định không đè gì → giữ */
    var w = c.width, h = c.height, pad = 8, yB = c.top, yT = k.top + pad;
    var cand = [
      [k.right - pad - w, yB], [k.left + pad, yB],
      [k.left + (k.width - w) / 2, yT], [k.left + pad, yT]
    ];
    for (var i = 0; i < cand.length; i++) {
      var x = cand[i][0], y = cand[i][1], box = { l: x, t: y, r: x + w, b: y + h };
      if (!obs.some(function (o) { return rectsHit(box, o); })) {
        chip.classList.add('em-zpos');
        chip.style.left = (x - s.left) + 'px'; chip.style.top = (y - s.top) + 'px';
        chip.style.bottom = 'auto'; chip.style.right = 'auto';
        return;
      }
    }
  }

  /* ---------- 2) bước Xem lại trên điện thoại: hình to cho hết khoảng trắng ---------- */
  function fillConfirm(m) {
    var isP = m.classList.contains('dmp-modal');
    var stg = m.querySelector(isP ? '.dmp-stage' : '.dmc-stage');
    if (!stg) return;
    var on = mqM.matches && m.classList.contains('is-confirm') && !m.classList.contains('tt-cf-big');
    if (!on) { if (stg.__emCv) { stg.style.removeProperty('--cv'); stg.__emCv = 0; } return; }
    var dlg = m.querySelector(isP ? '.dmp-dialog' : '.dmc-modal__dialog'),
        pnl = m.querySelector(isP ? '.dmp-panel--confirm' : '.dmc-panel--confirm'), /* v27.8: thêu ảnh lấy đúng bảng Xem lại (trước lấy .dmp-panel đầu tiên = bảng chỉnh đang ẩn, cao 0 → ảnh demo phình hết màn hình, che mục xác nhận) */
        cv = stg.querySelector(isP ? '.dmp-canvas' : '.dmc-stage > .dmc-canvas:not(.dmc-canvas--clone)');
    if (!dlg || !pnl || !cv) return;
    var spare = dlg.clientHeight - stg.offsetHeight - pnl.offsetHeight;
    if (Math.abs(spare) < 12 && stg.__emCv) return;
    var cur = cv.offsetWidth, nv = Math.max(140, Math.min(window.innerWidth - 32, cur + spare - 8));
    if (Math.abs(nv - cur) < 6) return;
    stg.style.setProperty('--cv', Math.round(nv) + 'px'); stg.__emCv = 1;
    window.dispatchEvent(new Event('resize'));
  }

  /* ---------- 3) thêu ảnh ---------- */
  var CAM = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 8h3l1.6-2.2h6.8L17 8h3a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z"/><circle cx="12" cy="13.2" r="3.6"/></svg>';
  function photoFix(m) {
    var ic = m.querySelector('.dmp-drop__icon');
    if (ic && !ic.classList.contains('em-svgi') && /[\u{1F300}-\u{1FAFF}]/u.test(ic.textContent)) { ic.classList.add('em-svgi'); ic.innerHTML = CAM; }
  }
  function photoZoomOut(root) {
    var s = root.__dmp; if (!s || s.__emZO) return; s.__emZO = 1;
    var op = Object.getPrototypeOf(s);
    if (op.__emZoomOut) return; op.__emZoomOut = 1;
    var _o = op.open;
    op.open = function () {
      var r = _o.apply(this, arguments), self = this;
      setTimeout(function () {
        if (self.modal && !self.modal.classList.contains('is-confirm') && self.zoom > 1 && self.zoomHint) self.zoomHint.click();
      }, 80);
      return r;
    };
  }

  /* ---------- 4) thiệp / hộp quà / túi giấy ---------- */
  function giftFix() {
    if (!H.classList.contains('em-tts') || document.querySelector('[data-dearem-customizer],[data-dearem-photo-customizer]')) return;
    if (!document.querySelector('.tt-price')) return;
    H.classList.add('em-gift');
    var card = !!document.querySelector('.dmc-msg');
    var sub = document.querySelector('.tt-price__sub'); if (sub && !sub.__em) { sub.__em = 1; sub.textContent = 'Đóng gói & giao cùng đơn hàng'; }
    var bd = document.querySelector('.tt-price__badge');
    if (bd && !bd.__em) { bd.__em = 1; [].slice.call(bd.childNodes).forEach(function (n) { if (n.nodeType === 3 && n.textContent.trim()) n.textContent = card ? ' VIẾT TAY' : ' QUÀ TẶNG'; }); }
    var hint = document.querySelector('.tt-price__hint'); if (hint && !hint.__em) { hint.__em = 1; hint.textContent = 'Giao cùng đơn'; }
    var tag = document.querySelector('.tt-tag'); if (tag && !tag.__em) { tag.__em = 1; if (card) tag.textContent = 'Viết tay'; else tag.style.display = 'none'; }
    [].slice.call(document.querySelectorAll('.tt-assure > span')).forEach(function (sp) { if (/Xem trước thiết kế/.test(sp.textContent)) sp.style.display = 'none'; });
    /* ô lời chúc vào bảng Mua ngay */
    var sh = document.querySelector('.tt-vsheet'), host = document.querySelector('.dmc-pdp');
    if (sh && host && !sh.contains(host)) {
      var body = sh.querySelector('.tt-sheet__bd2'), q = body && body.querySelector('.tt-qty');
      if (body) body.insertBefore(host, q || null);
    }
    var fn = document.querySelector('.dm-form-note');
    if (sh && fn && !sh.contains(fn)) { var bd2 = sh.querySelector('.tt-sheet__bd2'), q2 = bd2 && bd2.querySelector('.tt-qty'); if (bd2) bd2.insertBefore(fn, q2 || null); }
    /* khối đã chuyển vào bảng: bỏ class ẩn tt-x mà em-tts.js gắn lúc còn nằm ngoài (v26.3) */
    [host, fn].forEach(function (x) { if (x && sh && sh.contains(x) && x.classList.contains('tt-x')) { x.classList.remove('tt-x'); x.style.order = ''; } });
    var vsel = sh && sh.querySelector('.tt-vhead__sel');
    var vsv = sh && sh.querySelector('variant-selects');
    /* em-tts.js ghi lại "Chọn phân loại" mỗi 600ms → không ghi đè chữ gốc (gây nhảy chữ); ẩn dòng gốc, hiện 1 dòng riêng */
    if (vsel && (!vsv || !vsv.offsetHeight)) {
      var t = card ? 'Thiệp viết tay theo lời chúc của bạn' : 'Dear eM tự chọn form vừa sản phẩm';
      var mine = sh.querySelector('.em-vsel');
      if (!mine) { mine = document.createElement('div'); mine.className = 'tt-vhead__sel em-vsel'; vsel.parentNode.insertBefore(mine, vsel.nextSibling); }
      if (mine.textContent !== t) mine.textContent = t;
      vsel.classList.add('em-vsel-off');
    }
  }

  function tick() {
    [].slice.call(document.querySelectorAll('.dmc-modal.is-open')).forEach(function (m) { placeChip(m); fillConfirm(m); });
    [].slice.call(document.querySelectorAll('.dmp-modal.is-open')).forEach(function (m) { photoFix(m); fillConfirm(m); });
    [].slice.call(document.querySelectorAll('[data-dearem-photo-customizer]')).forEach(photoZoomOut);
    giftFix();
  }
  setInterval(tick, 300);
})();
